<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Техника</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" :lazy-validation="false">
            <v-autocomplete
              v-model="form.vehicle_type_id"
              :items="vehicleTypes"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Тип"
              placeholder="Выбрать тип"
              :rules="vehicleTypeRules"
              :readonly="readonly"
            ></v-autocomplete>
            <v-select
              v-model="form.suborder.measure_unit_id"
              :items="measureUnits"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Единица измерения"
              placeholder="Выбрать единицу измерения"
              :rules="measureUnitRules"
              :readonly="readonly"
            ></v-select>
            <v-text-field
              v-model="form.suborder.quantity"
              type="text"
              label="Количество"
              :rules="quantityRules"
              :readonly="readonly"
            ></v-text-field>
            <v-row>
              <v-col cols="11" sm="5">
                <v-menu
                  v-model="menuDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="readonly"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.date"
                      label="Дата"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="dateRules"
                      @blur="date = parseDate(form.date)"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="menuDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="11" sm="5">
                <v-menu
                  v-model="menuTime"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="readonly"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.time"
                      label="Время"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="timeRules"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="form.time"
                    @input="menuTime = false"
                    format="24hr"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-autocomplete
              v-model="form.address"
              :items="gecoderValues"
              :loading="gecoderLoading"
              :search-input.sync="gecoderSearch"
              hide-no-data
              hide-selected
              label="Адрес"
              placeholder="Укажите адрес"
              :rules="addressRules"
              auto-select-first
              :readonly="readonly"
            ></v-autocomplete>
            <v-text-field
              v-model="form.responsible_person"
              type="text"
              label="Ответственное лицо"
              :readonly="readonly"
            ></v-text-field>
            <v-radio-group
              v-model="form.payment_type"
              row
              label="Способ оплаты"
              :readonly="readonly"
            >
              <v-radio label="Наличный" value="cash"></v-radio>
              <v-radio label="Безналичный" value="non_cash"></v-radio>
            </v-radio-group>
            <v-textarea
              v-model="form.description"
              type="text"
              multi
              label="Описание"
              :readonly="readonly"
            ></v-textarea>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Закрыть</v-btn>
        <v-btn v-if="!readonly" color="primary" @click="onSubmit" :loading="submitting"
          >Сохранить</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "OrderDialog",
  data() {
    return {
      item: null,
      dialog: false,
      vehicleTypes: [],
      measureUnits: [],
      readonly: false,
      form: {
        vehicle_type_id: null,
        date: null,
        time: null,
        address: "",
        responsible_person: null,
        payment_type: "cash",
        description: "",
        suborder: {
          measure_unit_id: null,
          quantity: null,
        },
      },
      date: null,
      valid: true,
      vehicleTypeRules: [(v) => !!v || "не может быть пустым"],
      measureUnitRules: [(v) => !!v || "не может быть пустым"],
      quantityRules: [(v) => !!v || "не может быть пустым"],
      addressRules: [(v) => !!v || "не может быть пустым"],
      dateRules: [(v) => !!v || "не может быть пустым"],
      timeRules: [(v) => !!v || "не может быть пустым"],
      addresses: [],
      gecoderLoading: false,
      gecoderSearch: null,
      gecoderValue: null,
      submitting: false,
      menuDate: false,
      menuTime: false,
    };
  },
  computed: {
    gecoderValues() {
      return !this.gecoderValue
        ? this.addresses
        : [this.gecoderValue, ...this.addresses];
    },
  },
  watch: {
    date(val) {
      this.form.date = this.formatDate(val);
    },
    gecoderSearch(value) {
      if (this.isLoading || !value) return;

      this.isLoading = true;
      this.gecoderValue = value;

      this.$api.geocoder
        .select({ address: value })
        .then((response) => {
          this.addresses = response.data.map((item) => item.description);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    open(item, readonly = false) {
      if (this.$refs.form) this.$refs.form.reset();

      this.readonly = readonly;
      if (item) {
        this.form = {
          vehicle_type_id: item.vehicle_type_id,
          suborder: item.suborder,
          date: item.date,
          time: item.time,
          address: item.address,
          responsible_person: item.responsible_person,
          payment_type: item.payment_type,
          description: item.description,
        };
        this.gecoderValue = item.address;
        this.date = this.parseDate(item.date);
        this.item = item;
      }

      this.dialog = true;
      this.fetchData();
    },
    close() {
      this.item = null;
      this.reset();
      this.dialog = false;
      if (this.$refs.form) this.$refs.form.reset();
    },
    reset() {
      this.form = {
        vehicle_type_id: null,
        suborder: {
          measure_unit_id: null,
          quantity: null,
        },
        date: null,
        time: null,
        address: "",
        responsible_person: null,
        payment_type: "cash",
        description: "",
      };
    },
    fetchData() {
      this.$api.vehicle_types.select().then((response) => {
        this.vehicleTypes = response.data.items;
      });
      this.$api.measure_units.select().then((response) => {
        this.measureUnits = response.data.items;
      });
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.item && this.item.id) {
          this.updateOrder(this.item.id);
        } else {
          this.createOrder();
        }
      }
    },
    async createOrder() {
      this.submitting = true;
      this.$api["client/orders"]
        .create(this.form)
        .then(() => {
          this.$toast.success("Ваш заказ успешно создан.");
          this.$emit("submitted");
          this.close();
        })
        .catch((error) => {
          Object.values(error.response.data.errors).forEach((messages) => {
            messages.forEach((message) => {
              this.$toast.error(message, { icon: "fa-exclamation-circle" });
            });
          });
        })
        .finally(() => (this.submitting = false));
    },
    async updateOrder(id) {
      this.submitting = true;
      this.$api["client/orders"]
        .update(id, this.form)
        .then(() => {
          this.$toast.success("Заказ успешно обновлен.");
          this.$emit("submitted");
          this.close();
        })
        .catch((error) => {
          Object.values(error.response.data.errors).forEach((messages) => {
            messages.forEach((message) => {
              this.$toast.error(message, { icon: "fa-exclamation-circle" });
            });
          });
        })
        .finally(() => (this.submitting = false));
    },
  },
};
</script>